import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { PopupMessage } from "../PopupMessage";
import { Statuses, getStatusColour } from "./BoardModels";
import { ContentStyle, StatusContainerStyle } from "./styled";

const Content = ({ children }: { children: ReactNode }) => {
  return (
    <Typography sx={ContentStyle}>
      {children}
    </Typography>
  );
}

export const BoardShiftStatusInfo = ({ handleClick }: { handleClick: () => void }) => {
  return (
    <PopupMessage title="Shift Status Help" onClose={handleClick}>
      <Content>
        The Shift Status and Dispatch information is real time.  This information may change at anytime. Please refresh this page frequently to view the most recent data.
      </Content>
      <Content>
        The following are the various states of dispatch:
      </Content>
      <Content>
        <Typography
          component={"span"}
          sx={{
            ...StatusContainerStyle,
            color: getStatusColour(Statuses.pending),
          }}
        >
          Pending
        </Typography>
        : Indicates that the shift has not yet been dispatched, dispatch is in progress, or order pick up time has not yet been reached.<br />
      </Content>
      <Content>
        <Typography
          component={"span"}
          sx={{
            ...StatusContainerStyle,
            color: getStatusColour(Statuses.dispatched),
          }}
        >
          Dispatched
        </Typography>
        : Indicates that the shift has been completely dispatched and orders are available for pick up.
      </Content>
      <Content>
        <Typography
          component={"span"}
          sx={{
            ...StatusContainerStyle,
            color: getStatusColour(Statuses.suspended),
          }}
        >
          Suspended
        </Typography>
        : Indicates that the dispatchers have suspended this shift. Dispatch Office may suspend shifts from time to time and pursue a manual dispatch process, which may include contacting individuals directly. Also shifts may be suspended if the order pick up time has been exceeded. If you have not picked up your order prior to the shift being suspended, it is advisable to contact dispatch office to verify your current dispatch status.
      </Content>
      <Content>
        Shift Status, Dispatch and other related information displayed here are provided for informational purposes only. The Dispatch office and/or actual site personnel continue to be responsible for information displayed on this page.
      </Content>
    </PopupMessage>
  );
}